import { useAbandonedBookings } from 'components/Bookings2/Abandoned/AbandonedBookingsProvider';
import { AbandonedBookingCard } from 'components/Bookings2/Abandoned/Card/AbandonedBookingCard';
import styles from 'components/Bookings2/Abandoned/List/AbandonedBookingsList.module.scss';
import { Pagination } from 'components/UI/V3/Pagination/Pagination';
import React from 'react';

export const AbandonedBookingsList: React.FC = () => {
    const { page, size, setPage, setSize, totalPages, bookingAttempts, sendSmsHandler, openCreateBookingHandler } =
        useAbandonedBookings();

    return (
        <div className={styles.root}>
            {bookingAttempts.map(bookingAttempt => (
                <AbandonedBookingCard
                    key={bookingAttempt.id}
                    bookingAttempt={bookingAttempt}
                    onBook={openCreateBookingHandler}
                    onSendSms={sendSmsHandler}
                />
            ))}

            <Pagination
                size={size}
                page={page}
                totalPages={totalPages}
                onPageChange={setPage}
                onSizeChange={setSize}
            />
        </div>
    );
};
